module.exports = __webpack_public_path__ + "3222c89c45e84c8402e41301147e0eee.jpg";